export default __webpack_public_path__ + "static/media/home.a91f09b3.gif";